import api from '@shared/services/api';

export const structuralGroupService = {
    getAllLocations: async () => {
        try {
            const response = await api.get('/location-all');
            return response.data;
        } catch (error) {
            console.error('Error getting locations:', error);
            throw error;
        }
    },

    createStructuralGroup: async (data) => {
        try {
            const requestData = {
                code: data.code,
                type: data.type,
                segment: data.segment,
                subordination: data.subordination,
                status: data.status,
                empBranchId: data.company,
                empOfficeId: data.expensesCenter,
                locationId: data.location,
                hrOrgUnitLevelsId: data.level,
                shortDescription: data.abbreviation,
                longDescription: data.name,
                addPayedLeave: 0,
                openDate: data.validityFrom,
                closeDate: data.validityTo,
                created: "2025-08-04",
                siblingPriority: data.siblingPriority,
                nomenclatureItemBySegmentId: data.nomenclatureItemBySegmentId,
                nomenclatureItemByTypeOfDivisionId: data.nomenclatureItemByTypeOfDivisionId,
                addSubordination: data.addSubordination
            };

            if (data.parentId) {
                requestData.parentId = data.parentId;
            }

            const response = await api.post('/org-unit', requestData);
            return response.data;
        } catch (error) {
            console.error('Error creating structural group:', error);
            throw error;
        }
    },

    getStructuralGroupById: async (id) => {
        try {
            const response = await api.get(`/org-unit/get/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error getting structural group by ID:', error);
            throw error;
        }
    },

    updateStructuralGroup: async (id, data) => {
        try {
            const response = await api.put(`/org-unit/${id}`, {
                code: data.code,
                type: data.type,
                segment: data.segment,
                subordination: data.subordination,
                status: data.status,
                empBranchId: data.company,
                empOfficeId: data.expensesCenter,
                locationId: data.location,
                hrOrgUnitLevelsId: data.level,
                shortDescription: data.abbreviation,
                longDescription: data.name,
                addPayedLeave: 0,
                openDate: data.validityFrom,
                closeDate: data.validityTo,
                siblingPriority: data.siblingPriority,
                nomenclatureItemBySegmentId: data.nomenclatureItemBySegmentId,
                nomenclatureItemByTypeOfDivisionId: data.nomenclatureItemByTypeOfDivisionId,
                addSubordination: data.addSubordination
            });
            return response.data;
        } catch (error) {
            console.error('Error updating structural group:', error);
            throw error;
        }
    },
    deleteStructuralGroup: async (id) => {
        try {
            const response = await api.delete(`/org-unit/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting structural group:', error);
            throw error;
        }
    },

    getTranslation: async (orgUnitLevelsId) => {
        try {
            const response = await api.get(`/org-unit/translation/${orgUnitLevelsId}`);
            return response.data;
        } catch (error) {
            console.error('Error getting translation:', error);
            throw error;
        }
    },

    saveTranslation: async (translationData) => {
        try {
            const response = await api.post('/org-unit/translate', translationData);
            return response.data;
        } catch (error) {
            console.error('Error saving translation:', error);
            throw error;
        }
    },
    handleOpenPdfPositions: async (id, companyId) => {
        try {
            const response = await api.get(`/hr-positions/generateReport/docs?orgUnitId=${id}&companyId=${companyId}`, {
                responseType: 'blob',
                headers: {
                    'Accept': 'application/pdf',
                    'Content-Type': 'application/pdf'
                }
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(blob);
            const newTab = window.open(pdfUrl, '_blank');

            if (!newTab) {
                throw new Error('Failed to open new tab. Please check if popups are blocked.');
            }
            setTimeout(() => {
                URL.revokeObjectURL(pdfUrl);
            }, 1000);

            return response.data;
        } catch (error) {
            if (error.response?.status === 401) {
                console.error('Authentication error - please check if you are logged in');
            }
            console.error('Error opening PDF:', error);
            throw error;
        }
    },

    getPositionCounts: async (structuralGroupId) => {
        try {
            const response = await api.get(`/jobs/position-counts/${structuralGroupId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching position counts:', error);
            throw error;
        }
    },

    getPositionsByJobId: async (orgUnitId, hrJobId) => {
        try {
            const response = await api.get(`/hr-positions/job/${orgUnitId}/${hrJobId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching positions by job ID:', error);
            throw error;
        }
    },
    createStructuralGroupPositions: async (data) => {
        try {
            const formatedData = {
                locationId: data.locationId,
                hrJobId: data.hrJobId,
                hrOrgUnitId: data.hrOrgUnitId,
                positionNumber: data.positionNumber,
                openDate: data.openDate,
                closeDate: data.closeDate,
                status: data.status,
                orderPriority: data.orderPriority,
                ftePercent: data.ftePercent,
                budget: data.budget,
                hoursOfWork: data.hoursOfWork,
                hrPositionLevelId: data.structuralGroupId,
                managementLevelId: data.managementLevelId,
                addPayedLeave: data.addPayedLeave,
                costCenterId: data.costCenterId,
                numberOfPositions: data.numberOfPositions,
                hrJobDescriptionId: data.hrJobDescriptionId ? parseInt(data.hrJobDescriptionId) : null
            }
            const response = await api.post('/hr-positions', formatedData);
            return response.data;
        } catch (error) {
            console.error('Error creating structural group positions:', error);
            throw error;
        }
    },

    getStructuralGroupPositionById: async (id) => {
        try {
            const response = await api.get(`/hr-positions/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching structural group position by ID:', error);
            throw error;
        }
    },

    deleteStructuralGroupPosition: async (id) => {
        try {
            const response = await api.delete(`/hr-positions/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting structural group position:', error);
            throw error;
        }
    },

    updateStructuralGroupPosition: async (id, data) => {
        try {
            const formatedData = {
                locationId: data.locationId,
                hrJobId: data.hrJobId,
                hrOrgUnitId: data.hrOrgUnitId,
                positionNumber: data.positionNumber,
                openDate: data.openDate,
                closeDate: data.closeDate,
                status: data.status,
                orderPriority: data.orderPriority,
                ftePercent: data.ftePercent,
                budget: data.budget,
                hoursOfWork: data.hoursOfWork,
                hrPositionLevelId: data.structuralGroupId,
                managementLevelId: data.managementLevelId,
                addPayedLeave: data.addPayedLeave,
                costCenterId: data.costCenterId,
                hrJobDescriptionId: data.hrJobDescriptionId ? parseInt(data.hrJobDescriptionId) : null
            };
            const response = await api.put(`/hr-positions/${id}`, formatedData);
            return response.data;
        } catch (error) {
            console.error('Error updating structural group position:', error);
            throw error;
        }
    },
    getPositionOccupationHistory: async (hrPositionId) => {
        try {
            const response = await api.get(`/hr-positions/ocupation-hist/${hrPositionId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching position occupation history:', error);
            throw error;
        }
    },
    createPositionOccupationHistory: async (data) => {
        try {
            const requestData = {
                hrPositionId: data.hrPositionId,
                ocupantId: data.ocupantId,
                titularId: data.titularId,
                fromDate: data.fromDate,
                toDate: data.toDate
            };
            const response = await api.post('/hr-positions/ocupation-hist', requestData);
            return response.data;
        } catch (error) {
            console.error('Error creating position occupation history:', error);
            throw error;
        }
    },
    updatePositionOccupationHistory: async (id, data) => {
        try {
            const requestData = {
                hrPositionId: data.hrPositionId,
                ocupantId: data.ocupantId,
                titularId: data.titularId,
                fromDate: data.fromDate,
                toDate: data.toDate
            };
            const response = await api.put(`/hr-positions/ocupation-hist/${id}`, requestData);
            return response.data;
        } catch (error) {
            console.error('Error updating position occupation history:', error);
            throw error;
        }
    },
    deletePositionOccupationHistory: async (id) => {
        try {
            const response = await api.delete(`/hr-positions/ocupation-hist/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting position occupation history:', error);
            throw error;
        }
    },
    getPositionsCostCenter: async (hrPositionId) => {
        try {
            const response = await api.get(`/hr-positions/cost-center/${hrPositionId}`);
            return response.data;
        } catch (error) {
            console.error('Error getting positions cost center:', error);
            throw error;
        }
    },
    changePositionsCostCenter: async (data) => {
        try {
            const response = await api.post('/hr-positions/cost-center', data);
            return response.data;
        } catch (error) {
            console.error('Error changing positions cost center:', error);
            throw error;
        }
    },
    getOrgUnitCostCenterHierarchy: async (id) => {
        try {
            const response = await api.get(`/org-unit/cost-center-hierarchy/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error getting org unit cost center hierarchy:', error);
            throw error;
        }
    },
    getStructuralGroupMoving: async (id) => {
        try {
            const response = await api.get(`/hr-org-unit-hierarchy/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error getting structural group moving:', error);
            throw error;
        }
    },

    createStructuralGroupMoving: async (data) => {
        try {
            const requestData = {
                hrOrgUnitById: data.hrOrgUnitById,
                hrOrgUnitByParentId: data.hrOrgUnitByParentId,
                fromDate: data.fromDate
            };
            const response = await api.post('/hr-org-unit-hierarchy', requestData);
            return response.data;
        } catch (error) {
            console.error('Error creating structural group moving:', error);
            throw error;
        }
    },

    getStructuralGroupsByLevel: async (levelId, searchParams = {}) => {
        try {
            if (!levelId) {
                return [];
            }
            const params = new URLSearchParams();
            if (searchParams.code) {
                params.append('code', String(searchParams.code));
            }
            if (searchParams.longDescription) {
                params.append('longDescription', String(searchParams.longDescription));
            }
            if (searchParams.date) {
                params.append('date', String(searchParams.date));
            }
            const queryString = params.toString();
            const url = `/org-unit/${levelId}${queryString ? `?${queryString}` : ''}`;
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            console.error('❌ Error fetching structural groups by level:', error);
            throw error;
        }
    },

    getPositionCountsWithSearch: async (structuralGroupId, searchParams = {}) => {
        try {
            if (!structuralGroupId) {
                return [];
            }
            const params = new URLSearchParams();
            if (searchParams.code) {
                params.append('code', String(searchParams.code));
            }
            if (searchParams.name) {
                params.append('name', String(searchParams.name));
            }
            const queryString = params.toString();
            const url = `/jobs/position-counts/${structuralGroupId}${queryString ? `?${queryString}` : ''}`;
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            console.error('❌ Error fetching position counts with search:', error);
            throw error;
        }
    },

    getCheckboxPositionRights: async () => {
        try {
            const response = await api.get('/hr-positions/right-keys');
            return response.data;
        } catch (error) {
            console.error('Error fetching position rights:', error);
            throw error;
        }
    },
    getPositionRights: async (id) => {
        try {
            const response = await api.get(`/hr-positions/right/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching position rights by ID:', error);
            throw error;
        }
    },

    getPositionRightsById: async (id) => {
        try {
            const response = await api.get(`/hr-positions/right-by-id/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching position rights by ID:', error);
            throw error;
        }
    },

    getOrgUnitHierarchy: async (orgUnitId, companyId) => {
        try {
            const response = await api.get('/org-unit/report', {
                params: {
                    orgUnitId: orgUnitId,
                    companyId: companyId
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching org unit hierarchy:', error);
            throw error;
        }
    },

    createPositionRights: async (data) => {
        try {
            const requestData = {
                positionId: data.positionId,
                orgUnitId: data.orgUnitId,
                openDate: data.openDate,
                closeDate: data.closeDate,
                orderPriority: data.orderPriority,
                rightKeyIds: data.rightKeyIds,
                rightPosSalaryIds: data.rightPosSalaryIds
            };
            const response = await api.post('/hr-positions/right', requestData);
            return response.data;
        } catch (error) {
            console.error('Error creating position rights:', error);
            throw error;
        }
    },

    updatePositionRights: async (id, data) => {
        try {
            const requestData = {
                positionId: data.positionId,
                orgUnitId: data.orgUnitId,
                openDate: data.openDate,
                closeDate: data.closeDate,
                orderPriority: data.orderPriority,
                rightKeyIds: data.rightKeyIds,
                rightPosSalaryIds: data.rightPosSalaryIds
            };
            const response = await api.put(`/hr-positions/right/${id}`, requestData);
            return response.data;
        } catch (error) {
            console.error('Error updating position rights:', error);
            throw error;
        }
    },
    deletePositionRights: async (id) => {
        try {
            const response = await api.delete(`/hr-positions/right/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting position rights:', error);
            throw error;
        }
    },

    // Report data methods for frontend PDF/Excel generation
    getStructuralGroupsReportData: async (levelId) => {
        try {
            if (!levelId) {
                return [];
            }
            const response = await api.get(`/org-unit/${levelId}`);
            return response.data || [];
        } catch (error) {
            console.error('Error fetching structural groups report data:', error);
            throw error;
        }
    },
    generateReports: async (orgUnitId) => {
        try {
            if (!orgUnitId) {
                return [];
            }
            const params = {
                orgUnitId: orgUnitId
            };
            const response = await api.get(`/hr-positions/report`, { params });
            return response.data || [];
        } catch (error) {
            console.error('Error fetching positions report data:', error);
            throw error;
        }
    }
};